import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-placeholder",
  "use": "spr-placeholder-usage",
  "viewBox": "0 0 36 51",
  "content": "<symbol viewBox=\"0 0 36 51\" id=\"spr-placeholder\">\r\n<style type=\"text/css\">\r\n\t#spr-placeholder .st0{fill:#1081E0;}\r\n</style>\r\n<path class=\"st0\" d=\"M30.7,5.2L30.7,5.2c-7-7-18.4-7-25.5,0l0,0c-6.3,6.3-7,18.1-1.7,25.2L18,51l14.4-20.6\r\n\tC37.8,23.3,37.1,11.5,30.7,5.2z M18.2,23.5c-3.3,0-5.9-2.6-5.9-5.9s2.7-5.9,5.9-5.9s5.9,2.6,5.9,5.9S21.5,23.5,18.2,23.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/placeholder.svg
// module id = 339
// module chunks = 0